<template>
	<AppDialog disableMaxWidth width="1250px" ref="dialog_container" dialogName="AddAllowedEmailsDialog">
		<Row class="change-template-dialog pa-1">
			<Col class="left-side-container pt-1 ml-3">
				<Row class="header flex-justify-space-between width-100 mb-10 pr-3">
					<h1 class="cursor-pointer font-size-lg font-weight-500 py-2 pr-2"><b>Email templates</b></h1>
					<div class="cursor-pointer header-child btn py-1 create-template">+ Create a template</div>
				</Row>
				<Col v-for="(t, index) in templates" :key="`template-${index}-${t}`" class="template-list">
					<Row @click="loadTemplate({ text: t.value, id: t.id })" class="cursor-pointer py-2 template">{{ t.title }}</Row>
				</Col>
			</Col>

			<Col class="right-side-container pt-2">
				<Row class="header flex-justify-space-between width-100 pr-10">
					<span class="font-size-lg font-weight-500 header-child"><h2>Preview</h2></span>
					<Row class="">
						<div class="header-child">Used in {{ numOfFeaturesUsed }} features</div>
						<div class="header-child text-underline ml-2">{{ numOfDynamicFields }} dynamic fields</div>
						<div class="header-child cursor-pointer btn ml-2">Edit</div>
						<PrimaryButton class="ml-3" @click="selectTemplate">Select</PrimaryButton>
						<!-- <div>Actions</div> -->
					</Row>
				</Row>
				<Col class="mt-5 pt-4 main-template-content">{{ valToDisplay || templateVal }}</Col></Col
			>
		</Row>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { useEmailTemplatesArr } from '@/store/modules/transactionalEmailTemplate/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'ChangeEmailTemplateDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object } },
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		resolveWithValue(...args) {
			this.dialogPromiseHandlers.resolve(...args);
			this.close();
		},
		loadTemplate({ text, id }) {
			this.valToDisplay = text;
			this.selectedTemplateId = id;
		},
		selectTemplate() {
			this.resolveWithValue({ id: this.selectedTemplateId });
		},
	},
	computed: {
		...mapGettersShorthand({ useEmailTemplatesArr }),
		templates() {
			return this.useEmailTemplatesArr;
		},
		templateVal() {
			return this.templates[0].value;
		},
	},
	data() {
		return {
			selectedTemplateId: 1, // use default selected template id instead ?
			valToDisplay: '',
			// templateVal: this.templates[0].value, // TODO, use default selected template instead ?
			// email template data:
			isChangeTemplateMode: false,
			numOfFeaturesUsed: 3, // TODO, make real calculation
			numOfDynamicFields: 2, // TODO, make real calculation
		};
	},
};
</script>

<style scoped lang="scss">
.left-side {
	width: 20%;
	display: flex;
	flex-direction: column;
}

.header-child {
	padding: 6px 7px;
	&.btn {
		padding: 5px 7px;
		border: solid 1px #6060f7;
		border-radius: 8px;
		color: #6060f7;

		min-width: 80px;
		text-align: center;
	}
	&.create-template {
		padding-top: 7px !important;
	}
}

.change-template-dialog {
	height: 850px;
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;

	::v-deep {
		.v-icon {
			font-size: 16px !important;
		}
	}
}
.template {
	border-bottom: 2px solid #e4e8f3;
	border-radius: 2px;
}

.left-side-container {
	width: 35%;
	display: flex;
	flex-direction: column;
}
.right-side-container {
	padding-left: 12px;
	border-left: 5px solid #e4e8f3;
	height: 810px; // so border is seen for the full height
	width: 65%;
}
.main-template-content {
	font-size: 18px;
	border-top: 1px solid #e4e8f3;
	white-space: pre-wrap;
}
</style>
